// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ProjectRole = {
  Administrator: "administrator",
  Collaborator: "collaborator",
  Visitor: "visitor",
} as const;
export type ProjectRole = (typeof ProjectRole)[keyof typeof ProjectRole];

export function instanceOfProjectRole(value: any): boolean {
  for (const key in ProjectRole) {
    if (Object.prototype.hasOwnProperty.call(ProjectRole, key)) {
      if (ProjectRole[key as keyof typeof ProjectRole] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ProjectRoleFromJSON(json: any): ProjectRole {
  return ProjectRoleFromJSONTyped(json, false);
}

export function ProjectRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRole {
  return json as ProjectRole;
}

export function ProjectRoleToJSON(value?: ProjectRole | null): any {
  return value as any;
}

export function ProjectRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): ProjectRole {
  return value as ProjectRole;
}
